import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { Container } from '@cp/ds/src/components/container';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { SxProps, alpha } from '@mui/system';
import React from 'react';
import { BannerBaseProps } from './model';

const SHADOW_OPACITY = 0.2;

export const BannerBase: React.FC<BannerBaseProps> = ({ children, sx: sxFromProps }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  const sx: SxProps = {
    position: 'relative',
    height: 1,
    py: { xs: 3.75, [MOBILE_BREAKPOINT_THRESHOLD]: 5 },
    px: { [MOBILE_BREAKPOINT_THRESHOLD]: 5 },
    backgroundColor: { xs: theme.palette['gray ultra light'], [MOBILE_BREAKPOINT_THRESHOLD]: 'white' },
    borderRadius: { [MOBILE_BREAKPOINT_THRESHOLD]: `${theme.borderRadius.large}px` },
    boxShadow: { [MOBILE_BREAKPOINT_THRESHOLD]: `0px 0px 20px ${alpha(theme.palette.black, SHADOW_OPACITY)}` },
    ...sxFromProps,
  };

  const InnerContainer = isMobile ? Container : React.Fragment;
  const innerContainerProps = isMobile ? { sx } : undefined;

  return (
    <Box sx={!isMobile ? sx : undefined}>
      <InnerContainer {...innerContainerProps}>{children}</InnerContainer>
    </Box>
  );
};
